import { BookkeepingTag, BookkeepingTagLegacy, BookkeepingTagWithoutVatRates } from '../types/bookkeepingTag'

export const isLegacyBookkeepingTag = (
  answer: BookkeepingTag | BookkeepingTagLegacy | BookkeepingTagWithoutVatRates | undefined,
): answer is BookkeepingTagLegacy => {
  return answer !== undefined && 'option' in answer
}
